<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="
        w-full
        md:max-w-screen-lg
        flex flex-col
        bg-white
        rounded-sm
        shadow
        mx-auto
        py-10
        px-10
        mt-5
      "
    >
      <h2 class="text-2xl pb-5">Free Rental Application PDF</h2>
      <h2 class="text-2xl py-1">
        You're probably looking for a free rental application PDF.
      </h2>
      <Line />
      <p class="py-2 font-light">
        If that's all you want, you can download one at the end of this page.
      </p>
      <p class="py-2 font-light">
        <span class="font-semibold">BUT...</span> There's a much better
        option...
      </p>

      <h2 class="text-2xl pt-3">Benefits of our online application</h2>
      <Line />

      <ol class="list-decimal px-5">
        <li class="font-light py-1 px-1">
          <span class="font-semibold underline">Completely FREE</span> for
          landlords and property managers
        </li>
        <li class="font-light py-1 px-1">
          Can includes Credit Reports, Criminal Reports, and/or Eviction reports
          (You can ask the tenant to pay for this)
        </li>

        <li class="font-light py-1 px-1">
          Is 100% online -- so you can access it from anywhere
        </li>

        <li class="font-light py-1 px-1">
          Let's you customize the application form however you like
        </li>

        <li class="font-light py-1 px-1">And much more...</li>
      </ol>

      <h2 class="text-2xl pt-3">Like a PDF, but better</h2>
      <Line />
      <p class="py-2 font-light">
        It's basically exactly like a PDF application, but better because your
        applicant can complete it anywhere.
      </p>
      <p class="py-2 font-light">
        If you want any tenant screening options (credit, criminal, or
        eviction), the applicant pays and you get it in under 5 minutes. If you
        don't want to, you can just use a free form that's exactly like our PDF
        and its 100% free for BOTH you and the applicant (just like a PDF or
        paper application)
      </p>

      <h2 class="text-2xl pt-3">It's really awesome, ask our customers</h2>
      <Line />
      <p class="py-2 font-light">
        You can check out our customer testimonials by clicking on Testimonials
        from our
        <router-link
          :to="{ name: 'home_landing' }"
          class="text-brand-green cursor-pointer"
          >home page</router-link
        >.
      </p>
      <p class="py-2 font-light">
        Or just check it out yourself by taking a look at our sample application
        -- your applicants will see a sample application just like this:
      </p>

      <div class="flex md:w-1/3 mx-auto py-5">
        <PrimaryButton
          @click="goToSample"
          :classes="'bg-brand-blue border-brand-blue hover:bg-brand-blue'"
          >See Our Sample Application</PrimaryButton
        >
      </div>

      <p class="py-2 font-light">
        And the results get sent to you IMMEDIATELY.
      </p>

      <Line />
      <p class="py-2 font-light">
        You'll get your applications faster if you use our online application
        and it takes less than 30 seconds to set up.
      </p>
      <p class="py-2 font-light">
        However, if you're not interested at this time, we respect that too, so
        here's our default application as a PDF for your free use:
      </p>
      <div class="flex mx-auto py-5">
        <a
          href="https://s3.amazonaws.com/rent_app_media/%5Bwww.rentapplication.net%5D+Free+Rent+Application+Form+PDF.pdf"
          target="_self"
          download=""
        >
          <PrimaryButton
            :classes="'bg-brand-blue border-brand-blue hover:bg-brand-blue'"
            >No Thanks, I Just Want To Download The PDF</PrimaryButton
          ></a
        >
      </div>
      <p class="py-2 font-light">
        Rent Application (<router-link
          :to="{ name: 'home_landing' }"
          class="text-brand-green cursor-pointer"
          >{{ baseHostName }}</router-link
        >) makes it easy for landlords, property managers, and real estate
        agents to use an online rental application process for accepting
        applications and screening prospective tenants.
      </p>
      <p class="py-2 font-light">
        Rent Application is free for landlords and property managers and only
        charges applicants an application fee if the landlord or property
        manager asks for tenant screening reports to be included with the
        application ($19.95 for a full credit report).
      </p>
      <Line />
      <p class="py-2 font-light">
        Interested in finding out more about a faster, fully online application
        for screening prospective tenants?
      </p>
      <p class="py-2 font-light">Go to our home page for more info:</p>
      <div class="flex md:w-1/3 mx-auto py-5">
        <PrimaryButton
          @click="goToHome"
          :classes="'bg-brand-blue border-brand-blue hover:bg-brand-blue'"
          >Yes Please!</PrimaryButton
        >
      </div>
    </div>
  </div>
  <Footer />
</template>
<script>
export default {
  methods: {
    goToHome() {
      this.$router.push({ name: "home_landing" })
    },
    goToSample() {
      this.$router.push({ name: "apply_sample" })
    }
  }
}
</script>
